<template>
  <select class="form-control" v-model="selected">
    <option :value="null">---</option>
    <option :value="template.id" v-for="template in templates">
      <span>{{ template.name }}</span>
    </option>
  </select>
</template>
<script>
import _ from 'lodash';
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';

export default {
  props: ['value'],
  data: function () {
    return {
      selected: null,
      templates: []
    };
  },
  watch: {
    selected() {
      this.$emit('input', parseInt(this.selected));
    },
    value() {
      this.selected = parseInt(this.value);
    }
  },
  async mounted() {
    let { data: templates } = await Api.findAll('mail_templates');
    this.templates = templates;
    this.selected = parseInt(this.value);
  }
};
</script>

<style scoped></style>
